const staticMap = require('../static-file-map.json')
const versionator = require('versionator')
const mappedVersion = versionator.createMapped(staticMap)

module.exports = mappedVersion.versionPath
